import { Box, Typography, useTheme, alpha } from "@mui/material";
import RecyclingIcon from "@mui/icons-material/Recycling";
import {
  MONTHLY_MEMBER_BADGE_LABEL,
  BrandBadge,
  useIsMonthlyMember,
} from "@/features/brandBadge";
import {
  INHERITANCE_REUSE_SUBTITLE,
  INHERITANCE_REUSE_TITLE,
} from "@/features/inheritanceReuse/utils/constants";

/**
 * 相続後リユース候補画面のヘッダー。
 * R.E. DATA Plus プロダクト本体のトンマナ（白カード・淡いグレー境界・角丸控えめ・標準ウェイト、
 * ブランドのティール #32788F アクセント）に馴染ませた落ち着いた見出し。
 * 月額会員向けの特別感は、ティールのさりげないアクセントと月額会員バッジで控えめに表現する。
 * 派手なグラデーション・白グロー・極太フォントは用いない。
 */
export const InheritanceReuseHero: React.FC = () => {
  const theme = useTheme();
  const isMonthlyMember = useIsMonthlyMember();

  const teal = theme.palette.primary.main; // #32788F

  return (
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        borderRadius: 2,
        px: { xs: 2.5, md: 3 },
        py: { xs: 2.5, md: 3 },
        mb: 3,
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${theme.palette.border?.main ?? "#DDDDDD"}`,
        boxShadow: "0px 2px 8px -2px rgba(0, 0, 0, 0.25)",
        // 左端にブランドティールのさりげないアクセント。
        borderLeft: `3px solid ${teal}`,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            width: 44,
            height: 44,
            borderRadius: "50%",
            backgroundColor: alpha(teal, 0.12),
          }}
        >
          <RecyclingIcon sx={{ fontSize: 24, color: teal }} />
        </Box>

        <Box sx={{ minWidth: 0 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
              gap: 1.5,
              mb: 0.75,
            }}
          >
            <Typography
              component="h1"
              variant="h4"
              sx={{
                fontSize: { xs: 20, md: 22 },
                fontWeight: 600,
                color: theme.palette.black?.main ?? "#222222",
                lineHeight: 1.3,
              }}
            >
              {INHERITANCE_REUSE_TITLE}
            </Typography>
            {isMonthlyMember && (
              <BrandBadge label={MONTHLY_MEMBER_BADGE_LABEL} />
            )}
          </Box>
          <Typography
            sx={{
              fontSize: { xs: 13, md: 14 },
              lineHeight: 1.7,
              color: theme.palette.darkgray?.main ?? "#777777",
            }}
          >
            {INHERITANCE_REUSE_SUBTITLE}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
